import React from "react";
import PublicDishCircleProgressChart from "../PublicDishCircleProgressChart.jsx";

const DishParameterCard = ({ title, iconSrc, score, onClick, disabled, t }) => {
  const resolved = typeof score === "number" && score > 0 ? score : 0;
  const display = typeof score === "number" && score > 0 ? Math.round(score) : "•";

  return (
    <button
      type="button"
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      className={`relative flex flex-col items-center w-full min-w-0 max-w-full rounded-xl py-3 px-1.5 transition-colors border border-transparent ${
        disabled
          ? "opacity-40 cursor-not-allowed bg-neutral-200/50"
          : "cursor-pointer bg-neutral-200/60 hover:bg-neutral-300/70 active:bg-neutral-300"
      }`}
    >
      <div className="flex-shrink-0 w-full flex justify-center pointer-events-none">
        <PublicDishCircleProgressChart
          name={title}
          score={resolved}
          strokeWidth={8}
          originalSize={280}
          originalRadius={96}
          reductionFactor={0.44}
          centerContentInsetRatio={0.2}
          t={t}
        />
      </div>
      <div className="flex flex-col items-center justify-center min-w-0 w-full mt-1 gap-0.5 px-0.5">
        <div className="flex items-center justify-center gap-1 min-w-0">
          {iconSrc ? (
            <img src={iconSrc} alt="" className="w-6 h-6 tablet:w-7 tablet:h-7 object-contain flex-shrink-0" />
          ) : null}
          <p className="text-xs tablet:text-sm font-semibold text-gray-800 leading-tight m-0 text-center line-clamp-2 break-words">
            {t(title)}
          </p>
        </div>
        <p className="text-xs tablet:text-sm text-gray-600 m-0 tabular-nums">{display}/100</p>
      </div>
    </button>
  );
};

export default DishParameterCard;
